var items = {
  "block.minecraft.air": "aria",
  "block.minecraft.stone": "pietra",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito levigato",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "diorite levigata",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "andesite levigata",
  "block.minecraft.grass_block": "blocco d'erba",
  "block.minecraft.dirt": "terra",
  "block.minecraft.coarse_dirt": "terra brulla",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "necelio cremisi",
  "block.minecraft.warped_nylium": "necelio distorto",
  "block.minecraft.cobblestone": "pietrisco",
  "block.minecraft.oak_planks": "assi di quercia",
  "block.minecraft.spruce_planks": "assi di abete",
  "block.minecraft.birch_planks": "assi di betulla",
  "block.minecraft.jungle_planks": "assi della giungla",
  "block.minecraft.acacia_planks": "assi di acacia",
  "block.minecraft.dark_oak_planks": "assi di quercia scura",
  "block.minecraft.crimson_planks": "assi cremisi",
  "block.minecraft.warped_planks": "assi distorte",
  "block.minecraft.oak_sapling": "arboscello di quercia",
  "block.minecraft.spruce_sapling": "arboscello di abete",
  "block.minecraft.birch_sapling": "arboscello di betulla",
  "block.minecraft.jungle_sapling": "arboscello della giungla",
  "block.minecraft.acacia_sapling": "arboscello di acacia",
  "block.minecraft.dark_oak_sapling": "arboscello di quercia scura",
  "block.minecraft.bedrock": "bedrock",
  "block.minecraft.sand": "sabbia",
  "block.minecraft.red_sand": "sabbia rossa",
  "block.minecraft.gravel": "ghiaia",
  "block.minecraft.gold_ore": "minerale d'oro",
  "block.minecraft.iron_ore": "minerale di ferro",
  "block.minecraft.coal_ore": "minerale di carbone",
  "block.minecraft.nether_gold_ore": "minerale d'oro del nether",
  "block.minecraft.oak_log": "tronco di quercia",
  "block.minecraft.spruce_log": "tronco di abete",
  "block.minecraft.birch_log": "tronco di betulla",
  "block.minecraft.jungle_log": "tronco della giungla",
  "block.minecraft.acacia_log": "tronco di acacia",
  "block.minecraft.dark_oak_log": "tronco di quercia scura",
  "block.minecraft.crimson_stem": "gambo cremisi",
  "block.minecraft.warped_stem": "gambo distorto",
  "block.minecraft.stripped_oak_log": "tronco di quercia scortecciato",
  "block.minecraft.stripped_spruce_log": "tronco di abete scortecciato",
  "block.minecraft.stripped_birch_log": "tronco di betulla scortecciato",
  "block.minecraft.stripped_jungle_log": "tronco della giungla scortecciato",
  "block.minecraft.stripped_acacia_log": "tronco di acacia scortecciato",
  "block.minecraft.stripped_dark_oak_log": "tronco di quercia scura scortecciato",
  "block.minecraft.stripped_crimson_stem": "gambo cremisi scortecciato",
  "block.minecraft.stripped_warped_stem": "gambo distorto scortecciato",
  "block.minecraft.stripped_oak_wood": "legno di quercia scortecciato",
  "block.minecraft.stripped_spruce_wood": "legno di abete scortecciato",
  "block.minecraft.stripped_birch_wood": "legno di betulla scortecciato",
  "block.minecraft.stripped_jungle_wood": "legno della giungla scortecciato",
  "block.minecraft.stripped_acacia_wood": "legno di acacia scortecciato",
  "block.minecraft.stripped_dark_oak_wood": "legno di quercia scura scortecciato",
  "block.minecraft.stripped_crimson_hyphae": "ife cremisi scortecciate",
  "block.minecraft.stripped_warped_hyphae": "ife distorte scortecciate",
  "block.minecraft.oak_wood": "legno di quercia",
  "block.minecraft.spruce_wood": "legno di abete",
  "block.minecraft.birch_wood": "legno di betulla",
  "block.minecraft.jungle_wood": "legno della giungla",
  "block.minecraft.acacia_wood": "legno di acacia",
  "block.minecraft.dark_oak_wood": "legno di quercia scura",
  "block.minecraft.crimson_hyphae": "ife cremisi",
  "block.minecraft.warped_hyphae": "ife distorte",
  "block.minecraft.oak_leaves": "foglie di quercia",
  "block.minecraft.spruce_leaves": "foglie di abete",
  "block.minecraft.birch_leaves": "foglie di betulla",
  "block.minecraft.jungle_leaves": "foglie della giungla",
  "block.minecraft.acacia_leaves": "foglie di acacia",
  "block.minecraft.dark_oak_leaves": "foglie di quercia scura",
  "block.minecraft.sponge": "spugna",
  "block.minecraft.wet_sponge": "spugna bagnata",
  "block.minecraft.glass": "vetro",
  "block.minecraft.lapis_ore": "minerale di lapislazzuli",
  "block.minecraft.lapis_block": "blocco di lapislazzuli",
  "block.minecraft.dispenser": "distributore",
  "block.minecraft.sandstone": "arenaria",
  "block.minecraft.chiseled_sandstone": "arenaria cesellata",
  "block.minecraft.cut_sandstone": "arenaria incisa",
  "block.minecraft.note_block": "blocco sonoro",
  "block.minecraft.powered_rail": "binario alimentato",
  "block.minecraft.detector_rail": "binario rilevatore",
  "block.minecraft.sticky_piston": "pistone appiccicoso",
  "block.minecraft.cobweb": "ragnatela",
  "block.minecraft.grass": "erba",
  "block.minecraft.fern": "felce",
  "block.minecraft.dead_bush": "arbusto secco",
  "block.minecraft.seagrass": "erba acquatica",
  "block.minecraft.sea_pickle": "cetriolo di mare",
  "block.minecraft.piston": "pistone",
  "block.minecraft.white_wool": "lana bianca",
  "block.minecraft.orange_wool": "lana arancione",
  "block.minecraft.magenta_wool": "lana magenta",
  "block.minecraft.light_blue_wool": "lana azzurra",
  "block.minecraft.yellow_wool": "lana gialla",
  "block.minecraft.lime_wool": "lana lime",
  "block.minecraft.pink_wool": "lana rosa",
  "block.minecraft.gray_wool": "lana grigia",
  "block.minecraft.light_gray_wool": "lana grigio chiaro",
  "block.minecraft.cyan_wool": "lana ciano",
  "block.minecraft.purple_wool": "lana viola",
  "block.minecraft.blue_wool": "lana blu",
  "block.minecraft.brown_wool": "lana marrone",
  "block.minecraft.green_wool": "lana verde",
  "block.minecraft.red_wool": "lana rossa",
  "block.minecraft.black_wool": "lana nera",
  "block.minecraft.dandelion": "dente di leone",
  "block.minecraft.poppy": "papavero",
  "block.minecraft.blue_orchid": "orchidea blu",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "houstonia",
  "block.minecraft.red_tulip": "tulipano rosso",
  "block.minecraft.orange_tulip": "tulipano arancione",
  "block.minecraft.white_tulip": "tulipano bianco",
  "block.minecraft.pink_tulip": "tulipano rosa",
  "block.minecraft.oxeye_daisy": "margherita",
  "block.minecraft.cornflower": "fiordaliso",
  "block.minecraft.lily_of_the_valley": "mughetto",
  "block.minecraft.wither_rose": "rosa di wither",
  "block.minecraft.brown_mushroom": "fungo marrone",
  "block.minecraft.red_mushroom": "fungo rosso",
  "block.minecraft.crimson_fungus": "fungo cremisi",
  "block.minecraft.warped_fungus": "fungo distorto",
  "block.minecraft.crimson_roots": "radici cremisi",
  "block.minecraft.warped_roots": "radici distorte",
  "block.minecraft.nether_sprouts": "germogli del nether",
  "block.minecraft.weeping_vines": "rampicante piangente",
  "block.minecraft.twisting_vines": "rampicante attorcigliato",
  "block.minecraft.sugar_cane": "canna da zucchero",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambù",
  "block.minecraft.gold_block": "blocco d'oro",
  "block.minecraft.iron_block": "blocco di ferro",
  "block.minecraft.oak_slab": "lastra di quercia",
  "block.minecraft.spruce_slab": "lastra di abete",
  "block.minecraft.birch_slab": "lastra di betulla",
  "block.minecraft.jungle_slab": "lastra della giungla",
  "block.minecraft.acacia_slab": "lastra di acacia",
  "block.minecraft.dark_oak_slab": "lastra di quercia scura",
  "block.minecraft.crimson_slab": "lastra cremisi",
  "block.minecraft.warped_slab": "lastra distorta",
  "block.minecraft.stone_slab": "lastra di pietra",
  "block.minecraft.smooth_stone_slab": "lastra di pietra liscia",
  "block.minecraft.sandstone_slab": "lastra di arenaria",
  "block.minecraft.cut_sandstone_slab": "lastra di arenaria incisa",
  "block.minecraft.petrified_oak_slab": "lastra di quercia pietrificata",
  "block.minecraft.cobblestone_slab": "lastra di pietrisco",
  "block.minecraft.brick_slab": "lastra di mattoni",
  "block.minecraft.stone_brick_slab": "lastra di mattoni di pietra",
  "block.minecraft.nether_brick_slab": "lastra di mattoni del nether",
  "block.minecraft.quartz_slab": "lastra di quarzo",
  "block.minecraft.red_sandstone_slab": "lastra di arenaria rossa",
  "block.minecraft.cut_red_sandstone_slab": "lastra di arenaria rossa incisa",
  "block.minecraft.purpur_slab": "lastra di purpur",
  "block.minecraft.prismarine_slab": "lastra di prismarino",
  "block.minecraft.prismarine_brick_slab": "lastra di mattoni di prismarino",
  "block.minecraft.dark_prismarine_slab": "lastra di prismarino scuro",
  "block.minecraft.smooth_quartz": "blocco di quarzo liscio",
  "block.minecraft.smooth_red_sandstone": "arenaria rossa liscia",
  "block.minecraft.smooth_sandstone": "arenaria liscia",
  "block.minecraft.smooth_stone": "pietra liscia",
  "block.minecraft.bricks": "mattoni",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "libreria",
  "block.minecraft.mossy_cobblestone": "pietrisco muschioso",
  "block.minecraft.obsidian": "ossidiana",
  "block.minecraft.torch": "torcia",
  "block.minecraft.end_rod": "barra dell'end",
  "block.minecraft.chorus_plant": "pianta di chorus",
  "block.minecraft.chorus_flower": "fiore di chorus",
  "block.minecraft.purpur_block": "blocco di purpur",
  "block.minecraft.purpur_pillar": "pilastro di purpur",
  "block.minecraft.purpur_stairs": "scalini di purpur",
  "block.minecraft.spawner": "generatore",
  "block.minecraft.oak_stairs": "scalini di quercia",
  "block.minecraft.chest": "baule",
  "block.minecraft.diamond_ore": "minerale di diamante",
  "block.minecraft.diamond_block": "blocco di diamante",
  "block.minecraft.crafting_table": "banco da lavoro",
  "block.minecraft.farmland": "terra zappata",
  "block.minecraft.furnace": "fornace",
  "block.minecraft.ladder": "scala a pioli",
  "block.minecraft.rail": "binario",
  "block.minecraft.cobblestone_stairs": "scalini di pietrisco",
  "block.minecraft.lever": "leva",
  "block.minecraft.stone_pressure_plate": "pedana a pressione di pietra",
  "block.minecraft.oak_pressure_plate": "pedana a pressione di quercia",
  "block.minecraft.spruce_pressure_plate": "pedana a pressione di abete",
  "block.minecraft.birch_pressure_plate": "pedana a pressione di betulla",
  "block.minecraft.jungle_pressure_plate": "pedana a pressione della giungla",
  "block.minecraft.acacia_pressure_plate": "pedana a pressione di acacia",
  "block.minecraft.dark_oak_pressure_plate": "pedana a pressione di quercia scura",
  "block.minecraft.crimson_pressure_plate": "pedana a pressione cremisi",
  "block.minecraft.warped_pressure_plate": "pedana a pressione distorta",
  "block.minecraft.polished_blackstone_pressure_plate": "pedana a press. di pietranera levigata",
  "block.minecraft.redstone_ore": "minerale di redstone",
  "block.minecraft.redstone_torch": "torcia di redstone",
  "block.minecraft.snow": "neve",
  "block.minecraft.ice": "ghiaccio",
  "block.minecraft.snow_block": "blocco di neve",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "argilla",
  "block.minecraft.jukebox": "giradischi",
  "block.minecraft.oak_fence": "staccionata di quercia",
  "block.minecraft.spruce_fence": "staccionata di abete",
  "block.minecraft.birch_fence": "staccionata di betulla",
  "block.minecraft.jungle_fence": "staccionata della giungla",
  "block.minecraft.acacia_fence": "staccionata di acacia",
  "block.minecraft.dark_oak_fence": "staccionata di quercia scura",
  "block.minecraft.crimson_fence": "staccionata cremisi",
  "block.minecraft.warped_fence": "staccionata distorta",
  "block.minecraft.pumpkin": "zucca",
  "block.minecraft.carved_pumpkin": "zucca intagliata",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sabbia delle anime",
  "block.minecraft.soul_soil": "terra delle anime",
  "block.minecraft.basalt": "basalto",
  "block.minecraft.polished_basalt": "basalto levigato",
  "block.minecraft.soul_torch": "torcia delle anime",
  "block.minecraft.glowstone": "luminite",
  "block.minecraft.jack_o_lantern": "lanterna di zucca",
  "block.minecraft.oak_trapdoor": "botola di quercia",
  "block.minecraft.spruce_trapdoor": "botola di abete",
  "block.minecraft.birch_trapdoor": "botola di betulla",
  "block.minecraft.jungle_trapdoor": "botola della giungla",
  "block.minecraft.acacia_trapdoor": "botola di acacia",
  "block.minecraft.dark_oak_trapdoor": "botola di quercia scura",
  "block.minecraft.crimson_trapdoor": "botola cremisi",
  "block.minecraft.warped_trapdoor": "botola distorta",
  "block.minecraft.infested_stone": "pietra infestata",
  "block.minecraft.infested_cobblestone": "pietrisco infestato",
  "block.minecraft.infested_stone_bricks": "mattoni di pietra infestati",
  "block.minecraft.infested_mossy_stone_bricks": "mattoni di pietra muschiosi infestati",
  "block.minecraft.infested_cracked_stone_bricks": "mattoni di pietra crepati infestati",
  "block.minecraft.infested_chiseled_stone_bricks": "mattoni di pietra cesellati infestati",
  "block.minecraft.stone_bricks": "mattoni di pietra",
  "block.minecraft.mossy_stone_bricks": "mattoni di pietra muschiosi",
  "block.minecraft.cracked_stone_bricks": "mattoni di pietra crepati",
  "block.minecraft.chiseled_stone_bricks": "mattoni di pietra cesellati",
  "block.minecraft.brown_mushroom_block": "blocco di fungo marrone",
  "block.minecraft.red_mushroom_block": "blocco di fungo rosso",
  "block.minecraft.mushroom_stem": "gambo di fungo",
  "block.minecraft.iron_bars": "sbarre di ferro",
  "block.minecraft.chain": "catena",
  "block.minecraft.glass_pane": "pannello di vetro",
  "block.minecraft.melon": "anguria",
  "block.minecraft.vine": "rampicante",
  "block.minecraft.oak_fence_gate": "cancelletto di quercia",
  "block.minecraft.spruce_fence_gate": "cancelletto di abete",
  "block.minecraft.birch_fence_gate": "cancelletto di betulla",
  "block.minecraft.jungle_fence_gate": "cancelletto della giungla",
  "block.minecraft.acacia_fence_gate": "cancelletto di acacia",
  "block.minecraft.dark_oak_fence_gate": "cancelletto di quercia scura",
  "block.minecraft.crimson_fence_gate": "cancelletto cremisi",
  "block.minecraft.warped_fence_gate": "cancelletto distorto",
  "block.minecraft.brick_stairs": "scalini di mattoni",
  "block.minecraft.stone_brick_stairs": "scalini di mattoni di pietra",
  "block.minecraft.mycelium": "micelio",
  "block.minecraft.lily_pad": "ninfea",
  "block.minecraft.nether_bricks": "mattoni del nether",
  "block.minecraft.cracked_nether_bricks": "mattoni del nether crepati",
  "block.minecraft.chiseled_nether_bricks": "mattoni del nether cesellati",
  "block.minecraft.nether_brick_fence": "staccionata di mattoni del nether",
  "block.minecraft.nether_brick_stairs": "scalini di mattoni del nether",
  "block.minecraft.enchanting_table": "tavolo per incantesimi",
  "block.minecraft.end_portal_frame": "telaio del portale dell'end",
  "block.minecraft.end_stone": "pietra dell'end",
  "block.minecraft.end_stone_bricks": "mattoni di pietra dell'end",
  "block.minecraft.dragon_egg": "uovo di drago",
  "block.minecraft.redstone_lamp": "lampada a redstone",
  "block.minecraft.sandstone_stairs": "scalini di arenaria",
  "block.minecraft.emerald_ore": "minerale di smeraldo",
  "block.minecraft.ender_chest": "baule di ender",
  "block.minecraft.tripwire_hook": "gancio per filo ad inciampo",
  "block.minecraft.emerald_block": "blocco di smeraldo",
  "block.minecraft.spruce_stairs": "scalini di abete",
  "block.minecraft.birch_stairs": "scalini di betulla",
  "block.minecraft.jungle_stairs": "scalini della giungla",
  "block.minecraft.crimson_stairs": "scalini cremisi",
  "block.minecraft.warped_stairs": "scalini distorti",
  "block.minecraft.command_block": "blocco comandi",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "muretto di pietrisco",
  "block.minecraft.mossy_cobblestone_wall": "muretto di pietrisco muschioso",
  "block.minecraft.brick_wall": "muretto di mattoni",
  "block.minecraft.prismarine_wall": "muretto di prismarino",
  "block.minecraft.red_sandstone_wall": "muretto di arenaria rossa",
  "block.minecraft.mossy_stone_brick_wall": "muretto di mattoni di pietra muschiosi",
  "block.minecraft.granite_wall": "muretto di granito",
  "block.minecraft.stone_brick_wall": "muretto di mattoni di pietra",
  "block.minecraft.nether_brick_wall": "muretto di mattoni del nether",
  "block.minecraft.andesite_wall": "muretto di andesite",
  "block.minecraft.red_nether_brick_wall": "muretto di mattoni del nether rossi",
  "block.minecraft.sandstone_wall": "muretto di arenaria",
  "block.minecraft.end_stone_brick_wall": "muretto di mattoni di pietra dell'end",
  "block.minecraft.diorite_wall": "muretto di diorite",
  "block.minecraft.blackstone_wall": "muretto di pietranera",
  "block.minecraft.polished_blackstone_wall": "muretto di pietranera levigata",
  "block.minecraft.polished_blackstone_brick_wall": "muretto di mattoni di pietranera levigata",
  "block.minecraft.stone_button": "pulsante di pietra",
  "block.minecraft.oak_button": "pulsante di quercia",
  "block.minecraft.spruce_button": "pulsante di abete",
  "block.minecraft.birch_button": "pulsante di betulla",
  "block.minecraft.jungle_button": "pulsante della giungla",
  "block.minecraft.acacia_button": "pulsante di acacia",
  "block.minecraft.dark_oak_button": "pulsante di quercia scura",
  "block.minecraft.crimson_button": "pulsante cremisi",
  "block.minecraft.warped_button": "pulsante distorto",
  "block.minecraft.polished_blackstone_button": "pulsante di pietranera levigata",
  "block.minecraft.anvil": "incudine",
  "block.minecraft.chipped_anvil": "incudine scheggiata",
  "block.minecraft.damaged_anvil": "incudine danneggiata",
  "block.minecraft.trapped_chest": "baule trappola",
  "block.minecraft.light_weighted_pressure_plate": "pedana a pressione per piccoli pesi",
  "block.minecraft.heavy_weighted_pressure_plate": "pedana a pressione per pesi elevati",
  "block.minecraft.daylight_detector": "sensore di luce diurna",
  "block.minecraft.redstone_block": "blocco di redstone",
  "block.minecraft.nether_quartz_ore": "minerale di quarzo del nether",
  "block.minecraft.hopper": "tramoggia",
  "block.minecraft.chiseled_quartz_block": "blocco di quarzo cesellato",
  "block.minecraft.quartz_block": "blocco di quarzo",
  "block.minecraft.quartz_bricks": "mattoni di quarzo",
  "block.minecraft.quartz_pillar": "pilastro di quarzo",
  "block.minecraft.quartz_stairs": "scalini di quarzo",
  "block.minecraft.activator_rail": "binario attivatore",
  "block.minecraft.dropper": "gettatore",
  "block.minecraft.white_terracotta": "terracotta bianca",
  "block.minecraft.orange_terracotta": "terracotta arancione",
  "block.minecraft.magenta_terracotta": "terracotta magenta",
  "block.minecraft.light_blue_terracotta": "terracotta azzurra",
  "block.minecraft.yellow_terracotta": "terracotta gialla",
  "block.minecraft.lime_terracotta": "terracotta lime",
  "block.minecraft.pink_terracotta": "terracotta rosa",
  "block.minecraft.gray_terracotta": "terracotta grigia",
  "block.minecraft.light_gray_terracotta": "terracotta grigio chiaro",
  "block.minecraft.cyan_terracotta": "terracotta ciano",
  "block.minecraft.purple_terracotta": "terracotta viola",
  "block.minecraft.blue_terracotta": "terracotta blu",
  "block.minecraft.brown_terracotta": "terracotta marrone",
  "block.minecraft.green_terracotta": "terracotta verde",
  "block.minecraft.red_terracotta": "terracotta rossa",
  "block.minecraft.black_terracotta": "terracotta nera",
  "block.minecraft.barrier": "barriera",
  "block.minecraft.iron_trapdoor": "botola di ferro",
  "block.minecraft.hay_block": "balla di fieno",
  "block.minecraft.white_carpet": "tappeto bianco",
  "block.minecraft.orange_carpet": "tappeto arancione",
  "block.minecraft.magenta_carpet": "tappeto magenta",
  "block.minecraft.light_blue_carpet": "tappeto azzurro",
  "block.minecraft.yellow_carpet": "tappeto giallo",
  "block.minecraft.lime_carpet": "tappeto lime",
  "block.minecraft.pink_carpet": "tappeto rosa",
  "block.minecraft.gray_carpet": "tappeto grigio",
  "block.minecraft.light_gray_carpet": "tappeto grigio chiaro",
  "block.minecraft.cyan_carpet": "tappeto ciano",
  "block.minecraft.purple_carpet": "tappeto viola",
  "block.minecraft.blue_carpet": "tappeto blu",
  "block.minecraft.brown_carpet": "tappeto marrone",
  "block.minecraft.green_carpet": "tappeto verde",
  "block.minecraft.red_carpet": "tappeto rosso",
  "block.minecraft.black_carpet": "tappeto nero",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "blocco di carbone",
  "block.minecraft.packed_ice": "ghiaccio compatto",
  "block.minecraft.acacia_stairs": "scalini di acacia",
  "block.minecraft.dark_oak_stairs": "scalini di quercia scura",
  "block.minecraft.slime_block": "blocco di slime",
  "block.minecraft.grass_path": "sentiero d'erba",
  "block.minecraft.sunflower": "girasole",
  "block.minecraft.lilac": "lillà",
  "block.minecraft.rose_bush": "rosaio",
  "block.minecraft.peony": "peonia",
  "block.minecraft.tall_grass": "erba alta",
  "block.minecraft.large_fern": "felce grande",
  "block.minecraft.white_stained_glass": "vetro bianco",
  "block.minecraft.orange_stained_glass": "vetro arancione",
  "block.minecraft.magenta_stained_glass": "vetro magenta",
  "block.minecraft.light_blue_stained_glass": "vetro azzurro",
  "block.minecraft.yellow_stained_glass": "vetro giallo",
  "block.minecraft.lime_stained_glass": "vetro lime",
  "block.minecraft.pink_stained_glass": "vetro rosa",
  "block.minecraft.gray_stained_glass": "vetro grigio",
  "block.minecraft.light_gray_stained_glass": "vetro grigio chiaro",
  "block.minecraft.cyan_stained_glass": "vetro ciano",
  "block.minecraft.purple_stained_glass": "vetro viola",
  "block.minecraft.blue_stained_glass": "vetro blu",
  "block.minecraft.brown_stained_glass": "vetro marrone",
  "block.minecraft.green_stained_glass": "vetro verde",
  "block.minecraft.red_stained_glass": "vetro rosso",
  "block.minecraft.black_stained_glass": "vetro nero",
  "block.minecraft.white_stained_glass_pane": "pannello di vetro bianco",
  "block.minecraft.orange_stained_glass_pane": "pannello di vetro arancione",
  "block.minecraft.magenta_stained_glass_pane": "pannello di vetro magenta",
  "block.minecraft.light_blue_stained_glass_pane": "pannello di vetro azzurro",
  "block.minecraft.yellow_stained_glass_pane": "pannello di vetro giallo",
  "block.minecraft.lime_stained_glass_pane": "pannello di vetro lime",
  "block.minecraft.pink_stained_glass_pane": "pannello di vetro rosa",
  "block.minecraft.gray_stained_glass_pane": "pannello di vetro grigio",
  "block.minecraft.light_gray_stained_glass_pane": "pannello di vetro grigio chiaro",
  "block.minecraft.cyan_stained_glass_pane": "pannello di vetro ciano",
  "block.minecraft.purple_stained_glass_pane": "pannello di vetro viola",
  "block.minecraft.blue_stained_glass_pane": "pannello di vetro blu",
  "block.minecraft.brown_stained_glass_pane": "pannello di vetro marrone",
  "block.minecraft.green_stained_glass_pane": "pannello di vetro verde",
  "block.minecraft.red_stained_glass_pane": "pannello di vetro rosso",
  "block.minecraft.black_stained_glass_pane": "pannello di vetro nero",
  "block.minecraft.prismarine": "prismarino",
  "block.minecraft.prismarine_bricks": "mattoni di prismarino",
  "block.minecraft.dark_prismarine": "prismarino scuro",
  "block.minecraft.prismarine_stairs": "scalini di prismarino",
  "block.minecraft.prismarine_brick_stairs": "scalini di mattoni di prismarino",
  "block.minecraft.dark_prismarine_stairs": "scalini di prismarino scuro",
  "block.minecraft.sea_lantern": "lanterna marina",
  "block.minecraft.red_sandstone": "arenaria rossa",
  "block.minecraft.chiseled_red_sandstone": "arenaria rossa cesellata",
  "block.minecraft.cut_red_sandstone": "arenaria rossa incisa",
  "block.minecraft.red_sandstone_stairs": "scalini di arenaria rossa",
  "block.minecraft.repeating_command_block": "blocco comandi a ripetizione",
  "block.minecraft.chain_command_block": "blocco comandi a catena",
  "block.minecraft.magma_block": "blocco di magma",
  "block.minecraft.nether_wart_block": "blocco di verruche del nether",
  "block.minecraft.warped_wart_block": "blocco di verruche distorte",
  "block.minecraft.red_nether_bricks": "mattoni del nether rossi",
  "block.minecraft.bone_block": "blocco di ossa",
  "block.minecraft.structure_void": "vuoto della struttura",
  "block.minecraft.observer": "osservatore",
  "block.minecraft.shulker_box": "scatola di shulker",
  "block.minecraft.white_shulker_box": "scatola di shulker bianca",
  "block.minecraft.orange_shulker_box": "scatola di shulker arancione",
  "block.minecraft.magenta_shulker_box": "scatola di shulker magenta",
  "block.minecraft.light_blue_shulker_box": "scatola di shulker azzurra",
  "block.minecraft.yellow_shulker_box": "scatola di shulker gialla",
  "block.minecraft.lime_shulker_box": "scatola di shulker lime",
  "block.minecraft.pink_shulker_box": "scatola di shulker rosa",
  "block.minecraft.gray_shulker_box": "scatola di shulker grigia",
  "block.minecraft.light_gray_shulker_box": "scatola di shulker grigio chiaro",
  "block.minecraft.cyan_shulker_box": "scatola di shulker ciano",
  "block.minecraft.purple_shulker_box": "scatola di shulker viola",
  "block.minecraft.blue_shulker_box": "scatola di shulker blu",
  "block.minecraft.brown_shulker_box": "scatola di shulker marrone",
  "block.minecraft.green_shulker_box": "scatola di shulker verde",
  "block.minecraft.red_shulker_box": "scatola di shulker rossa",
  "block.minecraft.black_shulker_box": "scatola di shulker nera",
  "block.minecraft.white_glazed_terracotta": "terracotta smaltata bianca",
  "block.minecraft.orange_glazed_terracotta": "terracotta smaltata arancione",
  "block.minecraft.magenta_glazed_terracotta": "terracotta smaltata magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terracotta smaltata azzurra",
  "block.minecraft.yellow_glazed_terracotta": "terracotta smaltata gialla",
  "block.minecraft.lime_glazed_terracotta": "terracotta smaltata lime",
  "block.minecraft.pink_glazed_terracotta": "terracotta smaltata rosa",
  "block.minecraft.gray_glazed_terracotta": "terracotta smaltata grigia",
  "block.minecraft.light_gray_glazed_terracotta": "terracotta smaltata grigio chiaro",
  "block.minecraft.cyan_glazed_terracotta": "terracotta smaltata ciano",
  "block.minecraft.purple_glazed_terracotta": "terracotta smaltata viola",
  "block.minecraft.blue_glazed_terracotta": "terracotta smaltata blu",
  "block.minecraft.brown_glazed_terracotta": "terracotta smaltata marrone",
  "block.minecraft.green_glazed_terracotta": "terracotta smaltata verde",
  "block.minecraft.red_glazed_terracotta": "terracotta smaltata rossa",
  "block.minecraft.black_glazed_terracotta": "terracotta smaltata nera",
  "block.minecraft.white_concrete": "calcestruzzo bianco",
  "block.minecraft.orange_concrete": "calcestruzzo arancione",
  "block.minecraft.magenta_concrete": "calcestruzzo magenta",
  "block.minecraft.light_blue_concrete": "calcestruzzo azzurro",
  "block.minecraft.yellow_concrete": "calcestruzzo giallo",
  "block.minecraft.lime_concrete": "calcestruzzo lime",
  "block.minecraft.pink_concrete": "calcestruzzo rosa",
  "block.minecraft.gray_concrete": "calcestruzzo grigio",
  "block.minecraft.light_gray_concrete": "calcestruzzo grigio chiaro",
  "block.minecraft.cyan_concrete": "calcestruzzo ciano",
  "block.minecraft.purple_concrete": "calcestruzzo viola",
  "block.minecraft.blue_concrete": "calcestruzzo blu",
  "block.minecraft.brown_concrete": "calcestruzzo marrone",
  "block.minecraft.green_concrete": "calcestruzzo verde",
  "block.minecraft.red_concrete": "calcestruzzo rosso",
  "block.minecraft.black_concrete": "calcestruzzo nero",
  "block.minecraft.white_concrete_powder": "polvere di calcestruzzo bianca",
  "block.minecraft.orange_concrete_powder": "polvere di calcestruzzo arancione",
  "block.minecraft.magenta_concrete_powder": "polvere di calcestruzzo magenta",
  "block.minecraft.light_blue_concrete_powder": "polvere di calcestruzzo azzurra",
  "block.minecraft.yellow_concrete_powder": "polvere di calcestruzzo gialla",
  "block.minecraft.lime_concrete_powder": "polvere di calcestruzzo lime",
  "block.minecraft.pink_concrete_powder": "polvere di calcestruzzo rosa",
  "block.minecraft.gray_concrete_powder": "polvere di calcestruzzo grigia",
  "block.minecraft.light_gray_concrete_powder": "polvere di calcestruzzo grigio chiaro",
  "block.minecraft.cyan_concrete_powder": "polvere di calcestruzzo ciano",
  "block.minecraft.purple_concrete_powder": "polvere di calcestruzzo viola",
  "block.minecraft.blue_concrete_powder": "polvere di calcestruzzo blu",
  "block.minecraft.brown_concrete_powder": "polvere di calcestruzzo marrone",
  "block.minecraft.green_concrete_powder": "polvere di calcestruzzo verde",
  "block.minecraft.red_concrete_powder": "polvere di calcestruzzo rossa",
  "block.minecraft.black_concrete_powder": "polvere di calcestruzzo nera",
  "block.minecraft.turtle_egg": "uovo di tartaruga",
  "block.minecraft.dead_tube_coral_block": "blocco di corallo a tubo morto",
  "block.minecraft.dead_brain_coral_block": "blocco di corallo a cervello morto",
  "block.minecraft.dead_bubble_coral_block": "blocco di corallo a bolle morto",
  "block.minecraft.dead_fire_coral_block": "blocco di corallo di fuoco morto",
  "block.minecraft.dead_horn_coral_block": "blocco di corallo a corna morto",
  "block.minecraft.tube_coral_block": "blocco di corallo a tubo",
  "block.minecraft.brain_coral_block": "blocco di corallo a cervello",
  "block.minecraft.bubble_coral_block": "blocco di corallo a bolle",
  "block.minecraft.fire_coral_block": "blocco di corallo di fuoco",
  "block.minecraft.horn_coral_block": "blocco di corallo a corna",
  "block.minecraft.tube_coral": "corallo a tubo",
  "block.minecraft.brain_coral": "corallo a cervello",
  "block.minecraft.bubble_coral": "corallo a bolle",
  "block.minecraft.fire_coral": "corallo di fuoco",
  "block.minecraft.horn_coral": "corallo a corna",
  "block.minecraft.dead_brain_coral": "corallo a cervello morto",
  "block.minecraft.dead_bubble_coral": "corallo a bolle morto",
  "block.minecraft.dead_fire_coral": "corallo di fuoco morto",
  "block.minecraft.dead_horn_coral": "corallo a corna morto",
  "block.minecraft.dead_tube_coral": "corallo a tubo morto",
  "block.minecraft.tube_coral_fan": "gorgonia a tubo",
  "block.minecraft.brain_coral_fan": "gorgonia a cervello",
  "block.minecraft.bubble_coral_fan": "gorgonia a bolle",
  "block.minecraft.fire_coral_fan": "gorgonia di fuoco",
  "block.minecraft.horn_coral_fan": "gorgonia a corna",
  "block.minecraft.dead_tube_coral_fan": "gorgonia a tubo morta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia a cervello morta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia a bolle morta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia di fuoco morta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia a corna morta",
  "block.minecraft.blue_ice": "ghiaccio azzurro",
  "block.minecraft.conduit": "condotto",
  "block.minecraft.polished_granite_stairs": "scalini di granito levigato",
  "block.minecraft.smooth_red_sandstone_stairs": "scalini di arenaria rossa liscia",
  "block.minecraft.mossy_stone_brick_stairs": "scalini di mattoni di pietra muschiosi",
  "block.minecraft.polished_diorite_stairs": "scalini di diorite levigata",
  "block.minecraft.mossy_cobblestone_stairs": "scalini di pietrisco muschioso",
  "block.minecraft.end_stone_brick_stairs": "scalini di mattoni di pietra dell'end",
  "block.minecraft.stone_stairs": "scalini di pietra",
  "block.minecraft.smooth_sandstone_stairs": "scalini di arenaria liscia",
  "block.minecraft.smooth_quartz_stairs": "scalini di quarzo liscio",
  "block.minecraft.granite_stairs": "scalini di granito",
  "block.minecraft.andesite_stairs": "scalini di andesite",
  "block.minecraft.red_nether_brick_stairs": "scalini di mattoni del nether rossi",
  "block.minecraft.polished_andesite_stairs": "scalini di andesite levigata",
  "block.minecraft.diorite_stairs": "scalini di diorite",
  "block.minecraft.polished_granite_slab": "lastra di granito levigato",
  "block.minecraft.smooth_red_sandstone_slab": "lastra di arenaria rossa liscia",
  "block.minecraft.mossy_stone_brick_slab": "lastra di mattoni di pietra muschiosi",
  "block.minecraft.polished_diorite_slab": "lastra di diorite levigata",
  "block.minecraft.mossy_cobblestone_slab": "lastra di pietrisco muschioso",
  "block.minecraft.end_stone_brick_slab": "lastra di mattoni di pietra dell'end",
  "block.minecraft.smooth_sandstone_slab": "lastra di arenaria liscia",
  "block.minecraft.smooth_quartz_slab": "lastra di quarzo liscio",
  "block.minecraft.granite_slab": "lastra di granito",
  "block.minecraft.andesite_slab": "lastra di andesite",
  "block.minecraft.red_nether_brick_slab": "lastra di mattoni del nether rossi",
  "block.minecraft.polished_andesite_slab": "lastra di andesite levigata",
  "block.minecraft.diorite_slab": "lastra di diorite",
  "block.minecraft.scaffolding": "impalcatura",
  "block.minecraft.iron_door": "porta di ferro",
  "block.minecraft.oak_door": "porta di quercia",
  "block.minecraft.spruce_door": "porta di abete",
  "block.minecraft.birch_door": "porta di betulla",
  "block.minecraft.jungle_door": "porta della giungla",
  "block.minecraft.acacia_door": "porta di acacia",
  "block.minecraft.dark_oak_door": "porta di quercia scura",
  "block.minecraft.crimson_door": "porta cremisi",
  "block.minecraft.warped_door": "porta distorta",
  "block.minecraft.repeater": "ripetitore di redstone",
  "block.minecraft.comparator": "comparatore di redstone",
  "block.minecraft.structure_block": "blocco strutture",
  "block.minecraft.jigsaw": "blocco puzzle",
  "item.minecraft.turtle_helmet": "carapace di tartaruga□□in testa:□punti armatura: +2",
  "item.minecraft.scute": "scuto",
  "item.minecraft.iron_shovel": "pala di ferro□□nella mano principale:□danni per colpo: +3.5□velocità di attacco: -3",
  "item.minecraft.iron_pickaxe": "piccone di ferro□□nella mano principale:□danni per colpo: +3□velocità di attacco: -2.8",
  "item.minecraft.iron_axe": "ascia di ferro□□nella mano principale:□danni per colpo: +8□velocità di attacco: -3.1",
  "item.minecraft.flint_and_steel": "acciarino",
  "item.minecraft.apple": "mela",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "freccia",
  "item.minecraft.coal": "carbone",
  "item.minecraft.charcoal": "carbonella",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "lingotto di ferro",
  "item.minecraft.gold_ingot": "lingotto d'oro",
  "item.minecraft.netherite_ingot": "lingotto di netherite",
  "item.minecraft.netherite_scrap": "frammento di netherite",
  "item.minecraft.iron_sword": "spada di ferro□□nella mano principale:□danni per colpo: +5□velocità di attacco: -2.4",
  "item.minecraft.wooden_sword": "spada di legno□□nella mano principale:□danni per colpo: +3□velocità di attacco: -2.4",
  "item.minecraft.wooden_shovel": "pala di legno□□nella mano principale:□danni per colpo: +1.5□velocità di attacco: -3",
  "item.minecraft.wooden_pickaxe": "piccone di legno□□nella mano principale:□danni per colpo: +1□velocità di attacco: -2.8",
  "item.minecraft.wooden_axe": "ascia di legno□□nella mano principale:□danni per colpo: +6□velocità di attacco: -3.2",
  "item.minecraft.stone_sword": "spada di pietra□□nella mano principale:□danni per colpo: +4□velocità di attacco: -2.4",
  "item.minecraft.stone_shovel": "pala di pietra□□nella mano principale:□danni per colpo: +2.5□velocità di attacco: -3",
  "item.minecraft.stone_pickaxe": "piccone di pietra□□nella mano principale:□danni per colpo: +2□velocità di attacco: -2.8",
  "item.minecraft.stone_axe": "ascia di pietra□□nella mano principale:□danni per colpo: +8□velocità di attacco: -3.2",
  "item.minecraft.diamond_sword": "spada di diamante□□nella mano principale:□danni per colpo: +6□velocità di attacco: -2.4",
  "item.minecraft.diamond_shovel": "pala di diamante□□nella mano principale:□danni per colpo: +4.5□velocità di attacco: -3",
  "item.minecraft.diamond_pickaxe": "piccone di diamante□□nella mano principale:□danni per colpo: +4□velocità di attacco: -2.8",
  "item.minecraft.diamond_axe": "ascia di diamante□□nella mano principale:□danni per colpo: +8□velocità di attacco: -3",
  "item.minecraft.stick": "bastone",
  "item.minecraft.bowl": "ciotola",
  "item.minecraft.mushroom_stew": "zuppa di funghi",
  "item.minecraft.golden_sword": "spada d'oro□□nella mano principale:□danni per colpo: +3□velocità di attacco: -2.4",
  "item.minecraft.golden_shovel": "pala d'oro□□nella mano principale:□danni per colpo: +1.5□velocità di attacco: -3",
  "item.minecraft.golden_pickaxe": "piccone d'oro□□nella mano principale:□danni per colpo: +1□velocità di attacco: -2.8",
  "item.minecraft.golden_axe": "ascia d'oro□□nella mano principale:□danni per colpo: +6□velocità di attacco: -3",
  "item.minecraft.netherite_sword": "spada di netherite□□nella mano principale:□danni per colpo: +7□velocità di attacco: -2.4",
  "item.minecraft.netherite_shovel": "pala di netherite□□nella mano principale:□danni per colpo: +5.5□velocità di attacco: -3",
  "item.minecraft.netherite_pickaxe": "piccone di netherite□□nella mano principale:□danni per colpo: +5□velocità di attacco: -2.8",
  "item.minecraft.netherite_axe": "ascia di netherite□□nella mano principale:□danni per colpo: +9□velocità di attacco: -3",
  "item.minecraft.string": "cordicella",
  "item.minecraft.feather": "piuma",
  "item.minecraft.gunpowder": "polvere da sparo",
  "item.minecraft.wooden_hoe": "zappa di legno□□nella mano principale:□velocità di attacco: -3",
  "item.minecraft.stone_hoe": "zappa di pietra□□nella mano principale:□velocità di attacco: -2",
  "item.minecraft.iron_hoe": "zappa di ferro□□nella mano principale:□velocità di attacco: -1",
  "item.minecraft.diamond_hoe": "zappa di diamante□□nella mano principale:",
  "item.minecraft.golden_hoe": "zappa d'oro□□nella mano principale:□velocità di attacco: -3",
  "item.minecraft.netherite_hoe": "zappa di netherite□□nella mano principale:",
  "item.minecraft.wheat_seeds": "semi di grano",
  "item.minecraft.wheat": "grano",
  "item.minecraft.bread": "pane",
  "item.minecraft.leather_helmet": "casco di cuoio□□in testa:□punti armatura: +1",
  "item.minecraft.leather_chestplate": "giubba di cuoio□□sul torso:□punti armatura: +3",
  "item.minecraft.leather_leggings": "pantaloni di cuoio□□sulle gambe:□punti armatura: +2",
  "item.minecraft.leather_boots": "stivali di cuoio□□ai piedi:□punti armatura: +1",
  "item.minecraft.chainmail_helmet": "elmo di maglia□□in testa:□punti armatura: +2",
  "item.minecraft.chainmail_chestplate": "cotta di maglia□□sul torso:□punti armatura: +5",
  "item.minecraft.chainmail_leggings": "gambiere di maglia□□sulle gambe:□punti armatura: +4",
  "item.minecraft.chainmail_boots": "stivali di maglia□□ai piedi:□punti armatura: +1",
  "item.minecraft.iron_helmet": "elmo di ferro□□in testa:□punti armatura: +2",
  "item.minecraft.iron_chestplate": "corazza di ferro□□sul torso:□punti armatura: +6",
  "item.minecraft.iron_leggings": "gambiere di ferro□□sulle gambe:□punti armatura: +5",
  "item.minecraft.iron_boots": "stivali di ferro□□ai piedi:□punti armatura: +2",
  "item.minecraft.diamond_helmet": "elmo di diamante□□in testa:□punti armatura: +3□solidità dell'armatura: +2",
  "item.minecraft.diamond_chestplate": "corazza di diamante□□sul torso:□punti armatura: +8□solidità dell'armatura: +2",
  "item.minecraft.diamond_leggings": "gambiere di diamante□□sulle gambe:□punti armatura: +6□solidità dell'armatura: +2",
  "item.minecraft.diamond_boots": "stivali di diamante□□ai piedi:□punti armatura: +3□solidità dell'armatura: +2",
  "item.minecraft.golden_helmet": "elmo d'oro□□in testa:□punti armatura: +2",
  "item.minecraft.golden_chestplate": "corazza d'oro□□sul torso:□punti armatura: +5",
  "item.minecraft.golden_leggings": "gambiere d'oro□□sulle gambe:□punti armatura: +3",
  "item.minecraft.golden_boots": "stivali d'oro□□ai piedi:□punti armatura: +1",
  "item.minecraft.netherite_helmet": "elmo di netherite□□in testa:□punti armatura: +3□solidità dell'armatura: +3□resistenza al contraccolpo: +1",
  "item.minecraft.netherite_chestplate": "corazza di netherite□□sul torso:□punti armatura: +8□solidità dell'armatura: +3□resistenza al contraccolpo: +1",
  "item.minecraft.netherite_leggings": "gambiere di netherite□□sulle gambe:□punti armatura: +6□solidità dell'armatura: +3□resistenza al contraccolpo: +1",
  "item.minecraft.netherite_boots": "stivali di netherite□□ai piedi:□punti armatura: +3□solidità dell'armatura: +3□resistenza al contraccolpo: +1",
  "item.minecraft.flint": "selce",
  "item.minecraft.porkchop": "costoletta di maiale cruda",
  "item.minecraft.cooked_porkchop": "costoletta di maiale cotta",
  "item.minecraft.painting": "quadro",
  "item.minecraft.golden_apple": "mela d'oro",
  "item.minecraft.enchanted_golden_apple": "mela d'oro incantata",
  "block.minecraft.oak_sign": "cartello di quercia",
  "block.minecraft.spruce_sign": "cartello di abete",
  "block.minecraft.birch_sign": "cartello di betulla",
  "block.minecraft.jungle_sign": "cartello della giungla",
  "block.minecraft.acacia_sign": "cartello di acacia",
  "block.minecraft.dark_oak_sign": "cartello di quercia scura",
  "block.minecraft.crimson_sign": "cartello cremisi",
  "block.minecraft.warped_sign": "cartello distorto",
  "item.minecraft.bucket": "secchio",
  "item.minecraft.water_bucket": "secchio d'acqua",
  "item.minecraft.lava_bucket": "secchio di lava",
  "item.minecraft.minecart": "carrello da miniera",
  "item.minecraft.saddle": "sella",
  "item.minecraft.redstone": "polvere di redstone",
  "item.minecraft.snowball": "palla di neve",
  "item.minecraft.oak_boat": "barca di quercia",
  "item.minecraft.leather": "cuoio",
  "item.minecraft.milk_bucket": "secchio di latte",
  "item.minecraft.pufferfish_bucket": "secchio con pesce palla",
  "item.minecraft.salmon_bucket": "secchio con salmone",
  "item.minecraft.cod_bucket": "secchio con merluzzo",
  "item.minecraft.tropical_fish_bucket": "secchio con pesce tropicale",
  "item.minecraft.brick": "mattone",
  "item.minecraft.clay_ball": "zolla di argilla",
  "block.minecraft.dried_kelp_block": "blocco di alghe essiccate",
  "item.minecraft.paper": "carta",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "palla di slime",
  "item.minecraft.chest_minecart": "carrello da miniera con baule",
  "item.minecraft.furnace_minecart": "carrello da miniera con fornace",
  "item.minecraft.egg": "uovo",
  "item.minecraft.compass": "bussola",
  "item.minecraft.fishing_rod": "canna da pesca",
  "item.minecraft.clock": "orologio",
  "item.minecraft.glowstone_dust": "polvere di luminite",
  "item.minecraft.cod": "merluzzo crudo",
  "item.minecraft.salmon": "salmone crudo",
  "item.minecraft.tropical_fish": "pesce tropicale",
  "item.minecraft.pufferfish": "pesce palla",
  "item.minecraft.cooked_cod": "merluzzo cotto",
  "item.minecraft.cooked_salmon": "salmone cotto",
  "item.minecraft.ink_sac": "sacca d'inchiostro",
  "item.minecraft.red_dye": "colorante rosso",
  "item.minecraft.green_dye": "colorante verde",
  "item.minecraft.cocoa_beans": "fave di cacao",
  "item.minecraft.lapis_lazuli": "lapislazzuli",
  "item.minecraft.purple_dye": "colorante viola",
  "item.minecraft.cyan_dye": "colorante ciano",
  "item.minecraft.light_gray_dye": "colorante grigio chiaro",
  "item.minecraft.gray_dye": "colorante grigio",
  "item.minecraft.pink_dye": "colorante rosa",
  "item.minecraft.lime_dye": "colorante lime",
  "item.minecraft.yellow_dye": "colorante giallo",
  "item.minecraft.light_blue_dye": "colorante azzurro",
  "item.minecraft.magenta_dye": "colorante magenta",
  "item.minecraft.orange_dye": "colorante arancione",
  "item.minecraft.bone_meal": "farina di ossa",
  "item.minecraft.blue_dye": "colorante blu",
  "item.minecraft.brown_dye": "colorante marrone",
  "item.minecraft.black_dye": "colorante nero",
  "item.minecraft.white_dye": "colorante bianco",
  "item.minecraft.bone": "osso",
  "item.minecraft.sugar": "zucchero",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "letto bianco",
  "block.minecraft.orange_bed": "letto arancione",
  "block.minecraft.magenta_bed": "letto magenta",
  "block.minecraft.light_blue_bed": "letto azzurro",
  "block.minecraft.yellow_bed": "letto giallo",
  "block.minecraft.lime_bed": "letto lime",
  "block.minecraft.pink_bed": "letto rosa",
  "block.minecraft.gray_bed": "letto grigio",
  "block.minecraft.light_gray_bed": "letto grigio chiaro",
  "block.minecraft.cyan_bed": "letto ciano",
  "block.minecraft.purple_bed": "letto viola",
  "block.minecraft.blue_bed": "letto blu",
  "block.minecraft.brown_bed": "letto marrone",
  "block.minecraft.green_bed": "letto verde",
  "block.minecraft.red_bed": "letto rosso",
  "block.minecraft.black_bed": "letto nero",
  "item.minecraft.cookie": "biscotto",
  "item.minecraft.filled_map": "mappa□#0",
  "item.minecraft.shears": "cesoie",
  "item.minecraft.melon_slice": "fetta di anguria",
  "item.minecraft.dried_kelp": "alga essiccata",
  "item.minecraft.pumpkin_seeds": "semi di zucca",
  "item.minecraft.melon_seeds": "semi di anguria",
  "item.minecraft.beef": "manzo crudo",
  "item.minecraft.cooked_beef": "bistecca",
  "item.minecraft.chicken": "pollo crudo",
  "item.minecraft.cooked_chicken": "pollo cotto",
  "item.minecraft.rotten_flesh": "carne marcia",
  "item.minecraft.ender_pearl": "perla di ender",
  "item.minecraft.blaze_rod": "verga di blaze",
  "item.minecraft.ghast_tear": "lacrima di ghast",
  "item.minecraft.gold_nugget": "pepita d'oro",
  "item.minecraft.nether_wart": "verruca del nether",
  "item.minecraft.potion": "pozione non fabbricabile□nessun effetto",
  "item.minecraft.glass_bottle": "ampolla",
  "item.minecraft.spider_eye": "occhio di ragno",
  "item.minecraft.fermented_spider_eye": "occhio di ragno fermentato",
  "item.minecraft.blaze_powder": "polvere di blaze",
  "item.minecraft.magma_cream": "crema di magma",
  "block.minecraft.brewing_stand": "alambicco",
  "block.minecraft.cauldron": "calderone",
  "item.minecraft.ender_eye": "occhio di ender",
  "item.minecraft.glistering_melon_slice": "fetta di anguria luccicante",
  "item.minecraft.bat_spawn_egg": "uovo generatore di pipistrello",
  "item.minecraft.bee_spawn_egg": "uovo generatore di ape",
  "item.minecraft.blaze_spawn_egg": "uovo generatore di blaze",
  "item.minecraft.cat_spawn_egg": "uovo generatore di gatto",
  "item.minecraft.cave_spider_spawn_egg": "uovo generatore di ragno delle caverne",
  "item.minecraft.chicken_spawn_egg": "uovo generatore di gallina",
  "item.minecraft.cod_spawn_egg": "uovo generatore di merluzzo",
  "item.minecraft.cow_spawn_egg": "uovo generatore di mucca",
  "item.minecraft.creeper_spawn_egg": "uovo generatore di creeper",
  "item.minecraft.dolphin_spawn_egg": "uovo generatore di delfino",
  "item.minecraft.donkey_spawn_egg": "uovo generatore di asino",
  "item.minecraft.drowned_spawn_egg": "uovo generatore di annegato",
  "item.minecraft.elder_guardian_spawn_egg": "uovo generatore di guardiano antico",
  "item.minecraft.enderman_spawn_egg": "uovo generatore di enderman",
  "item.minecraft.endermite_spawn_egg": "uovo generatore di endermite",
  "item.minecraft.evoker_spawn_egg": "uovo generatore di evocatore",
  "item.minecraft.fox_spawn_egg": "uovo generatore di volpe",
  "item.minecraft.ghast_spawn_egg": "uovo generatore di ghast",
  "item.minecraft.guardian_spawn_egg": "uovo generatore di guardiano",
  "item.minecraft.hoglin_spawn_egg": "uovo generatore di hoglin",
  "item.minecraft.horse_spawn_egg": "uovo generatore di cavallo",
  "item.minecraft.husk_spawn_egg": "uovo generatore di zombi secco",
  "item.minecraft.llama_spawn_egg": "uovo generatore di lama",
  "item.minecraft.magma_cube_spawn_egg": "uovo generatore di cubo di magma",
  "item.minecraft.mooshroom_spawn_egg": "uovo generatore di mooshroom",
  "item.minecraft.mule_spawn_egg": "uovo generatore di mulo",
  "item.minecraft.ocelot_spawn_egg": "uovo generatore di ocelot",
  "item.minecraft.panda_spawn_egg": "uovo generatore di panda",
  "item.minecraft.parrot_spawn_egg": "uovo generatore di pappagallo",
  "item.minecraft.phantom_spawn_egg": "uovo generatore di phantom",
  "item.minecraft.pig_spawn_egg": "uovo generatore di maiale",
  "item.minecraft.piglin_spawn_egg": "uovo generatore di piglin",
  "item.minecraft.pillager_spawn_egg": "uovo generatore di predone",
  "item.minecraft.polar_bear_spawn_egg": "uovo generatore di orso polare",
  "item.minecraft.pufferfish_spawn_egg": "uovo generatore di pesce palla",
  "item.minecraft.rabbit_spawn_egg": "uovo generatore di coniglio",
  "item.minecraft.ravager_spawn_egg": "uovo generatore di devastatore",
  "item.minecraft.salmon_spawn_egg": "uovo generatore di salmone",
  "item.minecraft.sheep_spawn_egg": "uovo generatore di pecora",
  "item.minecraft.shulker_spawn_egg": "uovo generatore di shulker",
  "item.minecraft.silverfish_spawn_egg": "uovo generatore di pesciolino d'argento",
  "item.minecraft.skeleton_spawn_egg": "uovo generatore di scheletro",
  "item.minecraft.skeleton_horse_spawn_egg": "uovo generatore di cavallo scheletro",
  "item.minecraft.slime_spawn_egg": "uovo generatore di slime",
  "item.minecraft.spider_spawn_egg": "uovo generatore di ragno",
  "item.minecraft.squid_spawn_egg": "uovo generatore di calamaro",
  "item.minecraft.stray_spawn_egg": "uovo generatore di errante",
  "item.minecraft.strider_spawn_egg": "uovo generatore di strider",
  "item.minecraft.trader_llama_spawn_egg": "uovo generatore di lama del mercante",
  "item.minecraft.tropical_fish_spawn_egg": "uovo generatore di pesce tropicale",
  "item.minecraft.turtle_spawn_egg": "uovo generatore di tartaruga",
  "item.minecraft.vex_spawn_egg": "uovo generatore di vessante",
  "item.minecraft.villager_spawn_egg": "uovo generatore di villico",
  "item.minecraft.vindicator_spawn_egg": "uovo generatore di vendicatore",
  "item.minecraft.wandering_trader_spawn_egg": "uovo generatore di mercante ambulante",
  "item.minecraft.witch_spawn_egg": "uovo generatore di strega",
  "item.minecraft.wither_skeleton_spawn_egg": "uovo generatore di scheletro wither",
  "item.minecraft.wolf_spawn_egg": "uovo generatore di lupo",
  "item.minecraft.zoglin_spawn_egg": "uovo generatore di zoglin",
  "item.minecraft.zombie_spawn_egg": "uovo generatore di zombi",
  "item.minecraft.zombie_horse_spawn_egg": "uovo generatore di cavallo zombi",
  "item.minecraft.zombie_villager_spawn_egg": "uovo generatore di villico zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "uovo generatore di piglin zombificato",
  "item.minecraft.experience_bottle": "ampolla di esperienza",
  "item.minecraft.fire_charge": "carica di fuoco",
  "item.minecraft.writable_book": "libro e penna",
  "item.minecraft.written_book": "libro scritto",
  "item.minecraft.emerald": "smeraldo",
  "item.minecraft.item_frame": "cornice",
  "block.minecraft.flower_pot": "vaso da fiori",
  "item.minecraft.carrot": "carota",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata al forno",
  "item.minecraft.poisonous_potato": "patata velenosa",
  "item.minecraft.map": "mappa vuota",
  "item.minecraft.golden_carrot": "carota d'oro",
  "block.minecraft.skeleton_skull": "teschio di scheletro",
  "block.minecraft.wither_skeleton_skull": "teschio di scheletro wither",
  "block.minecraft.player_head": "testa di giocatore",
  "block.minecraft.zombie_head": "testa di zombi",
  "block.minecraft.creeper_head": "testa di creeper",
  "block.minecraft.dragon_head": "testa di drago",
  "item.minecraft.carrot_on_a_stick": "bastone e carota",
  "item.minecraft.warped_fungus_on_a_stick": "bastone e fungo distorto",
  "item.minecraft.nether_star": "stella del nether",
  "item.minecraft.pumpkin_pie": "torta di zucca",
  "item.minecraft.firework_rocket": "razzo pirotecnico",
  "item.minecraft.firework_star": "stella pirotecnica",
  "item.minecraft.enchanted_book": "libro incantato",
  "item.minecraft.nether_brick": "mattone del nether",
  "item.minecraft.quartz": "quarzo del nether",
  "item.minecraft.tnt_minecart": "carrello da miniera con tnt",
  "item.minecraft.hopper_minecart": "carrello da miniera con tramoggia",
  "item.minecraft.prismarine_shard": "scheggia di prismarino",
  "item.minecraft.prismarine_crystals": "cristalli di prismarino",
  "item.minecraft.rabbit": "coniglio crudo",
  "item.minecraft.cooked_rabbit": "coniglio cotto",
  "item.minecraft.rabbit_stew": "stufato di coniglio",
  "item.minecraft.rabbit_foot": "zampa di coniglio",
  "item.minecraft.rabbit_hide": "pelle di coniglio",
  "item.minecraft.armor_stand": "supporto per armature",
  "item.minecraft.iron_horse_armor": "bardatura di ferro",
  "item.minecraft.golden_horse_armor": "bardatura d'oro",
  "item.minecraft.diamond_horse_armor": "bardatura di diamante",
  "item.minecraft.leather_horse_armor": "bardatura di cuoio",
  "item.minecraft.lead": "guinzaglio",
  "item.minecraft.name_tag": "targhetta",
  "item.minecraft.command_block_minecart": "carrello da miniera con blocco comandi",
  "item.minecraft.mutton": "carne ovina cruda",
  "item.minecraft.cooked_mutton": "carne ovina cotta",
  "block.minecraft.white_banner": "stendardo bianco",
  "block.minecraft.orange_banner": "stendardo arancione",
  "block.minecraft.magenta_banner": "stendardo magenta",
  "block.minecraft.light_blue_banner": "stendardo azzurro",
  "block.minecraft.yellow_banner": "stendardo giallo",
  "block.minecraft.lime_banner": "stendardo lime",
  "block.minecraft.pink_banner": "stendardo rosa",
  "block.minecraft.gray_banner": "stendardo grigio",
  "block.minecraft.light_gray_banner": "stendardo grigio chiaro",
  "block.minecraft.cyan_banner": "stendardo ciano",
  "block.minecraft.purple_banner": "stendardo viola",
  "block.minecraft.blue_banner": "stendardo blu",
  "block.minecraft.brown_banner": "stendardo marrone",
  "block.minecraft.green_banner": "stendardo verde",
  "block.minecraft.red_banner": "stendardo rosso",
  "block.minecraft.black_banner": "stendardo nero",
  "item.minecraft.end_crystal": "cristallo dell'end",
  "item.minecraft.chorus_fruit": "frutto di chorus",
  "item.minecraft.popped_chorus_fruit": "frutto di chorus scoppiato",
  "item.minecraft.beetroot": "barbabietola",
  "item.minecraft.beetroot_seeds": "semi di barbabietola",
  "item.minecraft.beetroot_soup": "zuppa di barbabietole",
  "item.minecraft.dragon_breath": "soffio di drago",
  "item.minecraft.splash_potion": "pozione da lancio non fabbricabile□nessun effetto",
  "item.minecraft.spectral_arrow": "freccia spettrale",
  "item.minecraft.tipped_arrow": "freccia imbevuta non fabbricabile□nessun effetto",
  "item.minecraft.lingering_potion": "pozione persistente non fabbricabile□nessun effetto",
  "item.minecraft.shield": "scudo",
  "item.minecraft.elytra": "elitre",
  "item.minecraft.spruce_boat": "barca di abete",
  "item.minecraft.birch_boat": "barca di betulla",
  "item.minecraft.jungle_boat": "barca della giungla",
  "item.minecraft.acacia_boat": "barca di acacia",
  "item.minecraft.dark_oak_boat": "barca di quercia scura",
  "item.minecraft.totem_of_undying": "totem dell'immortalità",
  "item.minecraft.shulker_shell": "guscio di shulker",
  "item.minecraft.iron_nugget": "pepita di ferro",
  "item.minecraft.knowledge_book": "libro della conoscenza",
  "item.minecraft.debug_stick": "bastone di debug",
  "item.minecraft.music_disc_13": "disco musicale□c418 - 13",
  "item.minecraft.music_disc_cat": "disco musicale□c418 - cat",
  "item.minecraft.music_disc_blocks": "disco musicale□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disco musicale□c418 - chirp",
  "item.minecraft.music_disc_far": "disco musicale□c418 - far",
  "item.minecraft.music_disc_mall": "disco musicale□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disco musicale□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disco musicale□c418 - stal",
  "item.minecraft.music_disc_strad": "disco musicale□c418 - strad",
  "item.minecraft.music_disc_ward": "disco musicale□c418 - ward",
  "item.minecraft.music_disc_11": "disco musicale□c418 - 11",
  "item.minecraft.music_disc_wait": "disco musicale□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disco musicale□lena raine - pigstep",
  "item.minecraft.trident": "tridente□□nella mano principale:□danni per colpo: +8□velocità di attacco: -2.9",
  "item.minecraft.phantom_membrane": "membrana di phantom",
  "item.minecraft.nautilus_shell": "conchiglia di nautilus",
  "item.minecraft.heart_of_the_sea": "cuore del mare",
  "item.minecraft.crossbow": "balestra",
  "item.minecraft.suspicious_stew": "zuppa sospetta",
  "block.minecraft.loom": "telaio",
  "item.minecraft.flower_banner_pattern": "figura per stendardo□fiore",
  "item.minecraft.creeper_banner_pattern": "figura per stendardo□volto di creeper",
  "item.minecraft.skull_banner_pattern": "figura per stendardo□teschio",
  "item.minecraft.mojang_banner_pattern": "figura per stendardo□logo",
  "item.minecraft.globe_banner_pattern": "figura per stendardo□globo",
  "item.minecraft.piglin_banner_pattern": "figura per stendardo□grugno",
  "block.minecraft.composter": "compostiera",
  "block.minecraft.barrel": "barile",
  "block.minecraft.smoker": "affumicatore",
  "block.minecraft.blast_furnace": "forno fusorio",
  "block.minecraft.cartography_table": "banco da cartografia",
  "block.minecraft.fletching_table": "banco da impennatura",
  "block.minecraft.grindstone": "mola",
  "block.minecraft.lectern": "leggio",
  "block.minecraft.smithing_table": "banco da forgiatura",
  "block.minecraft.stonecutter": "tagliapietre",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "lanterna",
  "block.minecraft.soul_lantern": "lanterna delle anime",
  "item.minecraft.sweet_berries": "bacche dolci",
  "block.minecraft.campfire": "fuoco da campo",
  "block.minecraft.soul_campfire": "fuoco da campo delle anime",
  "block.minecraft.shroomlight": "fungolume",
  "item.minecraft.honeycomb": "favo",
  "block.minecraft.bee_nest": "alveare",
  "block.minecraft.beehive": "arnia",
  "item.minecraft.honey_bottle": "ampolla di miele",
  "block.minecraft.honey_block": "blocco di miele",
  "block.minecraft.honeycomb_block": "blocco di favi",
  "block.minecraft.lodestone": "magnetite",
  "block.minecraft.netherite_block": "blocco di netherite",
  "block.minecraft.ancient_debris": "detriti antichi",
  "block.minecraft.target": "bersaglio",
  "block.minecraft.crying_obsidian": "ossidiana piangente",
  "block.minecraft.blackstone": "pietranera",
  "block.minecraft.blackstone_slab": "lastra di pietranera",
  "block.minecraft.blackstone_stairs": "scalini di pietranera",
  "block.minecraft.gilded_blackstone": "pietranera dorata",
  "block.minecraft.polished_blackstone": "pietranera levigata",
  "block.minecraft.polished_blackstone_slab": "lastra di pietranera levigata",
  "block.minecraft.polished_blackstone_stairs": "scalini di pietranera levigata",
  "block.minecraft.chiseled_polished_blackstone": "pietranera levigata cesellata",
  "block.minecraft.polished_blackstone_bricks": "mattoni di pietranera levigata",
  "block.minecraft.polished_blackstone_brick_slab": "lastra di mattoni di pietranera levigata",
  "block.minecraft.polished_blackstone_brick_stairs": "scalini di mattoni di pietranera levigata",
  "block.minecraft.cracked_polished_blackstone_bricks": "mattoni di pietranera levigata crepati",
  "block.minecraft.respawn_anchor": "ancora della rinascita",
}
export const it_it = items; 
